// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1071":"20dcd3c5","3379":"c7a583df","4474":"20dcd3c5","5622":"e9066fd1"}[chunkId] + ".chunk.css";
};